import { getUnderground } from './getUnderground';
import { ELocationTypeId, type IOffer } from 'shared/offer';

import type { IGeoLabel } from '../../../../fragments/OfferCardWidget/shared/types/geo';

export const geoLabels = (offer: IOffer) => {
  const undergroundStation = getUnderground(offer);

  if (!offer.geo) {
    return [];
  }

  const isGeoAddressWithMetro = offer.geo.address.find(({ type }) => type === 'metro');

  const cityIndex = offer.geo.address.reduce(
    (cIndex, { locationTypeId }, index) => (locationTypeId === ELocationTypeId.City ? index + 1 : cIndex),
    1,
  );

  const geoLabels = offer.geo.address.map(
    ({ fullName, type }) =>
      ({
        label: fullName,
        type: type === 'metro' ? 'metro' : 'address',
        url: undefined,
      }) as IGeoLabel,
  );

  /**
   * Если есть underground, но нет метро внутри geo.address,
   * то добавляем метро вручную тут
   */
  if (undergroundStation && !isGeoAddressWithMetro) {
    geoLabels.splice(cityIndex, 0, {
      label: `м.\u00A0${undergroundStation.name}`,
      type: 'metro',
      url: undefined,
    });
  }

  return geoLabels;
};
